import { render, staticRenderFns } from "./invitation-newuser-bak.vue?vue&type=template&id=d6f9ea70&scoped=true&"
import script from "./invitation-newuser-bak.vue?vue&type=script&lang=js&"
export * from "./invitation-newuser-bak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6f9ea70",
  null
  
)

export default component.exports